<template>
  <div>
    <footer
      class="footer-crt"
      :class="{ [`footer-${type}`]: type }"
      :data-background-color="backgroundColor"
    >
      <!-- <div class="container pt-4">
        <div class="row">
          <div class="col-12 col-md-3 mb-3">
            <div class="stat-card">
              <i class="icon ri-user-line"></i>
              <div>
                <h4>9.999.999</h4>
                <p>Jogadores</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 mb-3">
            <div class="stat-card">
              <i class="icon ri-wifi-line"></i>
              <div>
                <h4>999</h4>
                <p>On-line</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 mb-3">
            <div class="stat-card">
              <img src="@/assets/openbox-yellow.svg" />
              <div>
                <h4>99.999.999</h4>
                <p>Caixas abertas</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 mb-3">
            <div class="stat-card">
              <i class="icon ri-star-line"></i>
              <div>
                <h4>Desde 2024</h4>
                <p>entregando experiências</p>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="container text-center text-md-left py-4">
        <div class="row align-items-center">
          <div class="col-xs-12 col-md-3">
            <router-link to="/">
              <img
                class="mb-3"
                style="max-width: 120px;"
                src="@/assets/logohor.webp"
              />
            </router-link>
            <!-- Lista de redes sociais -->
            <ul class="social-links">
              <li>
                <a href="https://www.instagram.com/boxdafiel" target="_blank"
                  ><i class="ri-instagram-line"></i
                ></a>
              </li>
            </ul>
          </div>
          <div class="col-xs-12 col-md-3">
            <nav class="nav-footer">
              <ul>
                <li>
                  <router-link class="nav-link" to="/">Home</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/comoFunciona"
                    >Como Funciona</router-link
                  >
                </li>
                <li>
                  <router-link class="nav-link" to="/Ajuda">Faq</router-link>
                </li>
                <li v-if="!decoded">
                  <a
                    href="javascript:void(0)"
                    class="nav-link "
                    @click="modalCadastrese = true"
                    >Cadastre-se</a
                  >
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-xs-12 col-md-3">
            <nav class="nav-footer">
              <ul>
                <li v-if="!decoded">
                  <a
                    href="javascript:void(0)"
                    class="nav-link "
                    @click="modalLogin = true"
                    >Entrar</a
                  >
                </li>
                <li>
                  <router-link class="nav-link" to="/TermosDeUso"
                    >Termos de Uso</router-link
                  >
                </li>
                <li>
                  <router-link class="nav-link" to="/PoliticaDePrivacidade"
                    >Política de Privacidade</router-link
                  >
                </li>
                <li class="flex">
                  <img
                    class="img-gray mt-12 p-2"
                    src="https://gamecomm.s3.amazonaws.com/pix-106.svg"
                    width="80px"
                  />
                  <img
                    class="img-gray p-2"
                    width="90"
                    src="@/assets/reclame-aqui-logo.png"
                  />
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-xs-12 col-md-3 text-center pt-3">
            <a href="https://gameecom.com/" target="_blank">
              <img
                class="img-gray"
                src="https://gamecomm.s3.amazonaws.com/logo-gamecomm.png"
              />
            </a>
          </div>
        </div>
      </div>

      <div class="text-center bottom-footer">
        &reg; {{ year }} {{ nomeEmpresa }} - Todos os direitos reservados
      </div>
    </footer>

    <modal
      :show.sync="modalLogin"
      :show-close="true"
      body-classes="p-3 pb-5"
      modal-classes="modal-dialog-centered "
    >
      <div>
        <formLogin
          :insideBox="true"
          @login="finalizaBoxLogin"
          :insideModal="true"
        ></formLogin>
      </div>
    </modal>

    <modal
      :show.sync="modalCadastrese"
      :show-close="true"
      body-classes="p-3 pb-5"
      modal-classes="modal-dialog-centered "
    >
      <slot name="header"><h3 class="text-white">Crie sua Conta</h3> </slot>
      <div>
        <formCadastro
          :insideBox="true"
          :insideLogin="true"
          @returnLogin="finalizaBoxLogin('voltar')"
          @CadastroConcluido="finalizaBoxLogin('Cadastro')"
        ></formCadastro>
      </div>
    </modal>

    <modal
      :show.sync="modalSaldo"
      :show-close="true"
      body-classes="p-3 pb-5"
      modal-classes="modal-dialog-centered "
    >
      <slot name="header"><h3 class="text-white">Adicionar Créditos</h3> </slot>
      <div>
        <formSaldo
          :insideBox="true"
          @saldoAtualizado="fechaModais"
          @erroLogin="finalizaBoxLogin('voltar')"
          @CloseModal="fechaModais"
        ></formSaldo>
      </div>
    </modal>
  </div>
</template>
<script>
import { Modal } from '@/components';
import formLogin from './../pages/components_site/formLogin.vue';
import formCadastro from './../pages/components_site/formCadastro.vue';
import formSaldo from './../pages/components_site/formPagamentos.vue';
import storage from './../services/storage';
import service from './../services';
import { KEY_LOCAL_STORAGE } from './../const';
export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  components: {
    formLogin,
    formCadastro,
    formSaldo,
    Modal,
  },
  data() {
    return {
      modalLogin: false,
      modalCadastrese: false,
      modalSaldo: false,
      nomeEmpresa: this.retornaNomeEmpresa(),
      linkLogo: this.retornaLinkLogo(),
      year: new Date().getFullYear(),
      decoded: service.getDecoded(),
      myInterval: null,
      subscribed: null,
    };
  },
  methods: {
    mounted() {},
    criaScriptRecaptcha() {
      console.log('criaScriptRecaptcha');
      let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute(
        'src',
        'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js',
      );
      recaptchaScript.setAttribute('type', 'text/javascript');
      recaptchaScript.setAttribute('id', 'ra-embed-verified-seal');

      recaptchaScript.setAttribute(
        'data-id',
        'dHh1R2FnUmhuR0UwUHdvYjpib3gtZGEtc29ydGUtY29tZXJjaW8tZGlnaXRhbA==',
      );
      recaptchaScript.setAttribute('data-target', 'ra-verified-seal2');
      recaptchaScript.setAttribute('data-model', '2');
      document.head.appendChild(recaptchaScript);
      console.log('recaptchaScript', recaptchaScript);
    },
    retornaLinkWhatsEmpresa() {
      let texto = `Olá!`;
      let textoEncode = encodeURI(texto);

      const link = `https://api.whatsapp.com/send?phone=5511934471420&text=${textoEncode}`;

      return link;
      //return process.env.VUE_APP_WHATSNUMBER;
    },
    retornaNomeEmpresa() {
      return process.env.VUE_APP_NOMEEMPRESA;
    },
    retornaLinkLogo() {
      return process.env.VUE_APP_LOGO;
    },
    returnLinkWhats() {
      const celular = '553199753003';
      let texto = `Olá Nilton, tudo bem? Gostaria de Saber mais informações sobre a gamecomm`;
      let textoEncode = encodeURI(texto);

      let link = '';
      link = `https://api.whatsapp.com/send?phone=5511934471420&text=${textoEncode}`;

      return link;
    },
    fechaModais() {
      this.modalLogin = false;
      this.modalCadastrese = false;
      this.modalSaldo = false;
    },
    finalizaBoxLogin(from) {
      this.fechaModais();
      if (from == 'Cadastro') this.modalSaldo = true;
      if (from == 'voltar') this.modalLogin = true;
    },
    changeLocalStorage() {
      this.decoded = service.getDecoded();
    },
  },
  created() {
    this.subscribed = storage.subscribe(this.changeLocalStorage);
    this.criaScriptRecaptcha();
  },

  beforeDestroy() {
    storage.unsubscribe(this.subscribed);
    clearInterval(this.myInterval);
  },
};
</script>

<style>
.modal-new {
  background-color: #19191b;
}
.stat-card {
  display: flex;
  align-items: center;
  justify-content: start;
  background-color: #1a1a1a;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.stat-card .icon {
  font-size: 32px;
  margin-right: 15px;
}

.stat-card img {
  width: 38px;
  margin-right: 15px;
  margin-top: 8px;
  padding: 3px;
}

.stat-card h4 {
  margin: 0;
  font-size: 1.2em;
  color: #fff;
}

.stat-card p {
  margin: 0;
  font-size: 0.9em;
  color: #b3b3b3;
}

@media (max-width: 768px) {
  .stat-card {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .stat-card .icon {
    margin-right: 0;
    margin-bottom: 10px;
  }
}

.footer-crt {
  background-color: #121212;
  color: #5e5e5e;
}

.formasdepagamento {
  display: block;
  clear: both;
  margin-top: 40px;
}

.social-links {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 10px;
}

.nav-link {
  color: #5e5e5e;
}

.nav-footer li {
  list-style: none;
  color: #5e5e5e;
}

.nav-footer li :hover {
  color: #ffffff;
}

.social-links li {
  display: flex;
  justify-content: center;
  align-items: center;
}

.social-links li a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #19191b;
  font-size: 24px;
  color: #5e5e5e;
  transition: background-color 0.3s;
  text-decoration: none;
}

.social-links li a:hover {
  background-color: #555;
  color: #fff;
}

.bottom-footer {
  background-color: #0e0e0e;
  padding: 18px;
}

.img-gray {
  filter: grayscale(100%);
}

@media (max-width: 768px) {
  footer {
    margin-bottom: 120px !important;
  }
  .footer-crt .row {
    flex-direction: column;
    align-items: center;
  }

  .footer-crt .col-xs-12 {
    margin-bottom: 20px;
  }

  .social-links {
    justify-content: center;
  }

  .nav-footer ul {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .bottom-footer {
    text-align: center;
  }

  .formasdepagamento {
    margin-top: 20px;
    text-align: center;
  }
}
</style>

<style lang="scss" scoped>
.whats {
  width: 70px;
  height: 70px;
  right: 10px;
  bottom: 20px;
  padding: 10px;
  display: block;
  opacity: 0.85;
  position: fixed;
  transition: opacity 0.1s;
  visibility: visible;
  z-index: 1049;
  img {
    width: 55px;
    height: 55px;
  }
}

.whats:hover {
  opacity: 1;
}
</style>
